import script from "./HeroBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeroBanner.vue?vue&type=script&lang=ts&setup=true"

import "./HeroBanner.vue?vue&type=style&index=0&id=8c2c8038&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c2c8038"]])

export default __exports__